import React from 'react';
import TopWave from './TopWave';
import BottomWave from './BottomWave';
import _ from 'lodash';
import style from 'dom-helpers/style';
import classnames from 'classnames';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { querySelectorAll, width, height, offset } from 'dom-helpers/query';
import { Hline, Logo, scrollTo } from './App';
import logos from './logos';
import './matchMedia.js';
import Slider from 'react-slick';

const sliderConf = {
  dots: true,
  infinite: true,
  speed: 500,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  slidesToScroll: 1
};

export const omission = (string, len = 30) => {
  if (!string) return;
  const check = () => {
    let length = len;
    let w;
    while (!!(w = string.substr(length, 1)) && w !== ' ') {
      length++;
    }
    return string.substr(0, length) + '...';
  };
  return string.length > len ? check() : string;
};

class Bio extends React.Component {
  state = {
    readfull: false
  };

  render() {
    const { readfull } = this.state;
    const { avator, name, role, desp, linkedin, center, ommision = true } = this.props;

    return (
      <div className="bio">
        {avator && avator()}
        <div className={classnames('thead', { tcenter: !ommision })}>
          <div className="left">
            <div className="bname">{name}</div>
            {!!role && <div className="brole" dangerouslySetInnerHTML={{ __html: role }} />}
          </div>
          {
            // !!linkedin && <a href={linkedin} target="_blank" className="linkedin" />
          }
        </div>
        {ommision ? (
          <p dangerouslySetInnerHTML={{ __html: readfull ? desp : omission(desp, 100) }} />
        ) : (
          <p className={classnames({ tcenter: !!center })} dangerouslySetInnerHTML={{ __html: desp }} />
        )}
        {ommision && !readfull && (
          <div className="readmore" onClick={() => this.setState({ readfull: true })}>
            Read more
          </div>
        )}
      </div>
    );
  }
}

export { Bio };

const LogoCube = ({ img, label, linkLabel, className, scaleNum, ...rest }) => (
  <a href={`//${linkLabel}`} target="_blank" className={classnames(className, 'logo')} {...rest}>
    <img src={img} alt="" style={{ transform: scaleNum ? `scale(${scaleNum})` : 'scale(1)' }} />
    <div className="pop">
      <p>{label}</p>
      <span>{linkLabel}</span>
    </div>
  </a>
);

const LogoCubeFake = ({ img, className, ...rest }) => (
  <div className={classnames(className, 'logo')} {...rest}>
    <img src={img} alt="" />
  </div>
);

class Frontpage extends React.Component {
  mx = 0;
  my = 0;

  state = {
    logoIndex: 0,
    slogan: 0
  };

  logoSlideNext = logos => {
    const { logoIndex } = this.state;
    if (logoIndex === logos.length - 1) return;
    this.setState({
      logoIndex: logoIndex + 1
    });
  };
  logoSlidePrev = logos => {
    const { logoIndex } = this.state;

    if (logoIndex === 0) return;
    this.setState({
      logoIndex: logoIndex - 1
    });
  };

  onScroll = event => {};
  onMousemove = event => {
    this.mx = event.screenX;
    this.my = event.screenY;
  };

  logoMouseEnter = event => {
    const nx = event.screenX;
    const ny = event.screenY;

    const blockWidth = width(event.currentTarget);
    const blockOffset = offset(event.currentTarget);
    const pop = _.first(querySelectorAll(event.currentTarget, '.pop'));

    this.selectedLogo = pop;
    let props;

    if (this.mx >= Math.floor(blockOffset.left) && this.mx < Math.floor(blockOffset.left + blockWidth)) {
      props = {
        left: 0,
        top: ny > this.my ? '-100%' : '100%',
        transition: 'none'
      };
    } else {
      props = {
        left: nx > this.mx ? '-100%' : '100%',
        top: 0,
        transition: 'none'
      };
    }
    props && style(pop, props);

    setTimeout(
      () =>
        style(pop, {
          left: 0,
          top: 0,
          transition: 'all .2s'
        }),
      0
    );
  };

  logoMouseLeave = event => {
    const nx = event.screenX;
    const ny = event.screenY;
    const blockWidth = width(event.currentTarget, true);
    const blockOffset = offset(event.currentTarget);
    const pop = _.first(querySelectorAll(event.currentTarget, '.pop'));
    let props;
    if (nx <= Math.floor(blockOffset.left) || nx >= Math.floor(blockOffset.left + blockWidth)) {
      props = {
        left: nx < blockOffset.left ? '-100%' : '100%',
        top: 0
      };
    } else if (ny < this.my || ny > this.my) {
      props = {
        left: 0,
        top: ny < this.my ? '-100%' : '100%'
      };
    }
    props && style(pop, props);
  };

  checkRoute({ match, location }) {
    if (location.pathname === '/vision') {
      scrollTo(offset(this.visionRef).top, 500);
    } else if (location.pathname === '/portfolio') {
      scrollTo(offset(this.portfolioRef).top, 500);
    } else if (location.pathname === '/about') {
      scrollTo(offset(this.aboutRef).top, 500);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.checkRoute(nextProps);
  }

  showNextSlogan = () => {
    this.setState({
      slogan: this.state.slogan === 5 ? 1 : this.state.slogan + 1
    });
  };

  componentDidMount() {
    this.checkRoute(this.props);
    document.addEventListener('scroll', this.onScroll);
    document.addEventListener('mousemove', this.onMousemove);

    TopWave.run(TopWave.init(this.canvasRef));

    this.interval = setInterval(() => this.showNextSlogan(), 5000);
    this.showNextSlogan();
  }

  componentWillUnmount() {
    this.interval && clearInterval(this.interval);
    this.interval = null;
    document.removeEventListener('scroll', this.onScroll);
    document.removeEventListener('mousemove', this.onMousemove);
  }
  render() {
    const { slogan, logoIndex } = this.state;

    const _logos = _.chunk(_.concat(logos, logos.length % 24 ? _.fill(new Array(24 - (logos.length % 24)), false) : []), 24);

    // const _logos = _.chunk(logos, 24);

    return (
      <div className="frontpage">
        <div className="topbanner">
          <div className={classnames('slogan s1', { show: slogan === 1 })}>
            <h1>
              <b>gf</b>
              <span className="title">network</span>
            </h1>
            <div className="tip">Together Everyone Achieves More</div>
          </div>

          <div className={classnames('slogan s2', { show: slogan === 2 })}>
            <div className="f1">
              <img src={require('./assets/connect.png')} />
            </div>
            <div className="f2">CAPITAL</div>
            <div className="tip">Together Everyone Achieves More</div>
          </div>

          <div className={classnames('slogan s2', { show: slogan === 3 })}>
            <div className="f1">
              <img src={require('./assets/connect.png')} />
            </div>
            <div className="f2">TALENT</div>
            <div className="tip">Together Everyone Achieves More</div>
          </div>

          <div className={classnames('slogan s2', { show: slogan === 4 })}>
            <div className="f1">
              <img src={require('./assets/connect.png')} />
            </div>
            <div className="f2" style={{ fontSize: 38 }}>
              INNOVATION
            </div>
            <div className="tip">Together Everyone Achieves More</div>
          </div>

          <div className={classnames('slogan s2', { show: slogan === 5 })}>
            <div className="f1">
              <img src={require('./assets/connect.png')} />
            </div>
            <div className="f2" style={{ fontSize: 40 }}>
              TECHNOLOGY
            </div>
            <div className="tip">Together Everyone Achieves More</div>
          </div>

          <canvas ref={ref => (this.canvasRef = ref)} />
        </div>

        <div className="vision">
          <Hline label="our" title="VISION" getRef={ref => (this.visionRef = ref)} />
          <div className="cont">
            <div className="t1">The vision of gf.network is</div>
            <div className="t2">"Together Everyone Achieves More"</div>
            <div className="t3">
              By sharing resources and cooperating with each other,
              <br />
              gf.network will more effectively build a global blockchain ecosystem for the future.
            </div>
            <div className="t4 d-md-none">
              gf.network has its offices <br />
              in{' '}
              <span className="blue">
                Shanghai and Beijing in <br />
                China; San Francisco and <br />
                Atlanta in the United States,
                <br /> and multiple cities in Europe.
              </span>
            </div>
            <div className="t4 d-none d-md-block">
              gf.network has its offices in{' '}
              <span className="blue">
                Shanghai and Beijing in China; San Francisco and <br />
                Atlanta in the United States, and multiple cities in Europe.
              </span>
            </div>
            <div className="t5 d-md-none">
              gf.network aims at con-
              <br />
              necting values globally.
            </div>
            <div className="t5 d-none d-md-block">gf.network aims at connecting values globally.</div>
          </div>
        </div>

        <div className="portfolio" ref={ref => (this.portfolioRef = ref)}>
          <Hline label="More" title="Portfolio" />

          <Slider {...sliderConf} className="d-md-none">
            {_logos.map((chunk, c) => (
              <div className="logo-cont-outer" key={c}>
                <div className={classnames('row mx-0')}>
                  {chunk.map((item, i) =>
                    item ? (
                      <LogoCube
                        key={i}
                        className={classnames('col-3 px-0', { lastitem: i > chunk.length - 5 })}
                        label={item.label}
                        linkLabel={item.linkLabel}
                        img={item.img}
                        scaleNum={item.scaleNum}
                      />
                    ) : (
                      <div className="logo col-3 px-0 lastitem" key={i} />
                    )
                  )}
                </div>
              </div>
            ))}
          </Slider>

          <Slider {...sliderConf} className="d-none d-md-block">
            {_logos.map((chunk, c) => (
              <div className="logo-cont-wrapper" key={c}>
                <div className="logo-cont-outer">
                  <div className={classnames('row mx-0', { lastrow: c === _logos.length - 1 })}>
                    {chunk.map((item, i) =>
                      item ? (
                        <LogoCube
                          key={i}
                          className={classnames('col-2 px-0', { lastitem: i > chunk.length - 7 })}
                          label={item.label}
                          linkLabel={item.linkLabel}
                          img={item.img}
                          scaleNum={item.scaleNum}
                        />
                      ) : (
                        <div className="logo col-2 px-0 lastitem" key={i} />
                      )
                    )}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        <div className="aboutus" ref={ref => (this.aboutRef = ref)}>
          <BottomWave />
          <Hline label="About" title="Us" />
          <div className="cont">
            <h3>
              <Logo height={20} /> is a new brand which includes Fenbushi Capital, Fenbushi Digital, BlockAsset, as well as other top-tier
              blockchain projects.
            </h3>
            <div className="row mx-0">
              <div className="col-md-4 card-cont">
                <div className="xcard">
                  <div className="pic pic-capital" />
                  <p>The first Asian VC focused on blockchain</p>
                </div>
              </div>
              <div className="col-md-4 card-cont">
                <div className="xcard">
                  <div className="pic pic-digital" />
                  <p>Building the foundation for a decentralized world</p>
                </div>
              </div>
              <div className="col-md-4 card-cont">
                <div className="xcard">
                  <div className="pic pic-blockset" />
                  <p>Driving the emergence of financial inclusion and decentralization</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="team">
          <Hline label="Our" title="Team" />
          <h3>
            {/* <Logo height={20} /> is founded by Shen Bo and other partners at Fenbushi Capital. It covers equity funds, global token funds,
            global incubators as well as other institutions which are all dedicated to the healthy development of blockchain industry. */}
            <Logo height={20} /> is founded by Shen Bo, other partners at Fenbushi Capital and veterans in the crypto-space. <br />
            It covers ………
          </h3>
          <div className="cont">
            <div className="line-both-sides stitle">
              <span className="mon first">core team</span>
            </div>

            <div className="row mx-0">
              <div className="col-lg-4 px-0">
                <Bio
                  avator={() => (
                    <div className="avator">
                      <img src={require('./assets/shenbo.png')} />
                    </div>
                  )}
                  name="Bo Shen"
                  ommision={false}
                  role="Founding Partner of gf.network and Fenbushi Capital"
                  desp="As the founding partner of gf.network and Fenbushi Capital, Mr. Shen has a remarkably high reputation in blockchain industry. He is one of China’s early blockchain entrepreneurs and investors, and co-founder of Bitshares. He has over 25 years of experience in asset management and traditional finance in North America and Asia."
                  linkedin="https://www.linkedin.com/in/boshen1011/"
                />
              </div>
              <div className="col-lg-4 px-0">
                <Bio
                  avator={() => (
                    <div className="avator">
                      <img src={require('./assets/wangliming.png')} />
                    </div>
                  )}
                  name="Ong, Remington"
                  ommision={false}
                  role="Partner of gf.network, Partner at Fenbushi Capital"
                  desp="Mr. Ong has managed investments into over 40 leading startups around the world leveraging blockchain technology to disrupt a wide range of industries. Previously, he has over 10 years of experience in investment banking and private equity in China, including as an investment banker covering Asia TMT at Merrill Lynch and as a management consultant at L.E.K. Consulting."
                  linkedin="https://www.linkedin.com/in/remingtonong/"
                />
              </div>
              <div className="col-lg-4 px-0">
                <Bio
                  avator={() => (
                    <div className="avator">
                      <img src={require('./assets/yuwenbo.png')} />
                    </div>
                  )}
                  name="Yu, Wenbo"
                  ommision={false}
                  role="Partner of gf.network, Partner at Fenbushi Capital"
                  desp="Mr. Yu is experienced in industry research and investment for over 20 years. He used to work at Delong International Investment Group, CICC Investment Group and Wanxiang Blockchain Laboratory. "
                  linkedin=""
                />
              </div>
              {/* <div className="col-lg-4 px-0">
              <Bio
                avator={()=><div className="avator"><img src={require("./assets/yaojingyi.png")} /></div>}
                name="Yao, Jingyi"
                ommision={false}
                role="Partner of gf.network, Partner at Fenbushi Capital"
                desp="Ms. Yao is a partner at Fenbushi Capital. She was previously the portfolio director of BVCF, and has worked with Greenwoods Asset Management and CICC. She has a deep understanding and professional experience in primary market, secondary market and asset management of Chinese capital market."
                linkedin=""
              />
            </div> */}
              {/* <div className="col-lg-2" /> */}
              <div className="col-lg-4 px-0">
                <Bio
                  avator={() => (
                    <div className="avator">
                      <img src={require('./assets/sunming.png')} />
                    </div>
                  )}
                  name="Sun, Roland"
                  ommision={false}
                  role="General Counsel of gf.network, Partner at Broad&Bright, General Counsel of Fenbushi Capital"
                  desp="Mr. Sun is experienced in foreign direct investment and mergers and acquisitions. Meanwhile, Mr. Sun is one of the earliest researchers and legal experts in cryptocurrencies and blockchain technology in China. He has been advising a number of blockchain technology start-ups both home and abroad."
                  linkedin=""
                />
              </div>

              <div className="col-lg-4 px-0">
                <Bio
                  avator={() => (
                    <div className="avator">
                      <img src={require('./assets/yang_peter.png')} />
                    </div>
                  )}
                  name="Yang, Peter"
                  ommision={false}
                  role="Managing Director of gf.network and Fenbushi Capital"
                  desp="Peter Yang, Fenbushi Capital Managing Director. Peter first discovered cryptocurreny in 2013 while in high school. Before joining Fenbushi in 2018, Peter previously worked at MUFG as a credit risk data analyst building models to assess default probability and default related losses. While studying at University of Georgia, Peter also interned at BNY Mellon and Everbright Bank performing operational and market risk management. Peter graduated in 2015 with a degrees in Statistics, and Risk Manangement & Insurance."
                  linkedin=""
                />
              </div>
            </div>
            <div className="line-both-sides stitle">
              <Link to="/teams" onClick={() => scrollTo(0, 0)} className="teammore">
                Know our full team
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Frontpage);

// WEBPACK FOOTER //
// ./src/Frontpage.js
